<template>
  <div class="page-card">
    <h2 class="page-title">管理员管理</h2>

    <div class="toolbar">
      <div class="toolbar-left">
        <el-input
          v-model="query.keyword"
          placeholder="账号/姓名/手机号"
          clearable
          style="width: 260px"
        />
        <el-select v-model="query.accountStatus" clearable placeholder="状态" style="width: 140px">
          <el-option label="启用" :value="1" />
          <el-option label="停用" :value="0" />
        </el-select>
        <el-button type="primary" @click="fetchData">查询</el-button>
      </div>
      <el-button type="primary" @click="openDialog()">新增管理员</el-button>
    </div>

    <el-table :data="list" border>
      <el-table-column prop="username" label="账号" />
      <el-table-column prop="realName" label="姓名" />
      <el-table-column prop="mobile" label="手机号" />
      <el-table-column prop="email" label="邮箱" />
      <el-table-column label="角色">
        <template slot-scope="{ row }">
          {{ formatRoleNames(row.roleNames) }}
        </template>
      </el-table-column>
      <el-table-column prop="accountStatus" label="状态" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="row.accountStatus === 1 ? 'success' : 'info'">
            {{ row.accountStatus === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="lastLoginAt" label="最后登录时间" width="180" />
      <el-table-column label="操作" width="280">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDialog(row)">编辑</el-button>
          <el-button v-if="row.accountStatus === 1" type="text" @click="changeStatus(row, 'disable')">停用</el-button>
          <el-button v-else type="text" @click="changeStatus(row, 'enable')">启用</el-button>
          <el-button type="text" @click="openResetDialog(row)">重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.id ? '编辑管理员' : '新增管理员'" :visible.sync="dialogVisible" width="520px">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username" :disabled="!!form.id" />
        </el-form-item>
        <el-form-item v-if="!form.id" label="初始密码" prop="password">
          <el-input v-model="form.password" show-password />
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-input v-model="form.realName" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item label="状态" prop="accountStatus">
          <el-radio-group v-model="form.accountStatus">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="角色" prop="roleIds">
          <el-select v-model="form.roleIds" multiple style="width: 100%">
            <el-option
              v-for="item in roleOptions"
              :key="item.id"
              :label="item.roleName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="重置密码" :visible.sync="resetVisible" width="420px">
      <el-form ref="resetRef" :model="resetForm" :rules="resetRules" label-width="100px">
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="resetForm.newPassword" show-password />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="resetVisible = false">取消</el-button>
        <el-button type="primary" @click="submitReset">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  createAdminUser,
  disableAdminUser,
  enableAdminUser,
  getAdminUsers,
  resetAdminPassword,
  updateAdminUser
} from '../../../api/adminUser'
import { getAdminRoles } from '../../../api/adminRole'

function getDefaultForm() {
  return {
    id: null,
    username: '',
    password: '123456',
    realName: '',
    mobile: '',
    email: '',
    accountStatus: 1,
    roleIds: []
  }
}

export default {
  name: 'AdminUserPage',
  data() {
    return {
      list: [],
      roleOptions: [],
      query: {
        keyword: '',
        accountStatus: undefined
      },
      dialogVisible: false,
      resetVisible: false,
      currentRow: null,
      form: getDefaultForm(),
      resetForm: {
        newPassword: ''
      },
      formRules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入初始密码', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        accountStatus: [{ required: true, message: '请选择状态', trigger: 'change' }],
        roleIds: [{ required: true, message: '请选择角色', trigger: 'change' }]
      },
      resetRules: {
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.fetchRoles()
    this.fetchData()
  },
  methods: {
    formatRoleNames(roleNames) {
      return Array.isArray(roleNames) ? roleNames.join('、') : ''
    },
    async fetchRoles() {
      this.roleOptions = await getAdminRoles()
    },
    async fetchData() {
      this.list = await getAdminUsers(this.query)
    },
    openDialog(row) {
      this.dialogVisible = true
      this.form = row ? { ...getDefaultForm(), ...row, password: '123456' } : getDefaultForm()
    },
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        if (this.form.id) {
          await updateAdminUser(this.form.id, this.form)
        } else {
          await createAdminUser(this.form)
        }
        this.dialogVisible = false
        this.fetchData()
      })
    },
    async changeStatus(row, type) {
      if (type === 'enable') {
        await enableAdminUser(row.id)
      } else {
        await disableAdminUser(row.id)
      }
      this.fetchData()
    },
    openResetDialog(row) {
      this.currentRow = row
      this.resetForm = { newPassword: '' }
      this.resetVisible = true
    },
    submitReset() {
      this.$refs.resetRef.validate(async valid => {
        if (!valid) return
        await resetAdminPassword(this.currentRow.id, this.resetForm)
        this.resetVisible = false
      })
    }
  }
}
</script>
